import NavigationToPlanSelection from '@spa/components/pages/paid-membership/subscribe/components/note/NavigationToPlanSelection.vue'
import PaidMembershipPlanNote from '@spa/components/pages/paid-membership/subscribe/components/note/PaidMembershipPlanNote.vue'
import {
  PaidMembershipSubscribeInteraction
} from '@spa/components/pages/paid-membership/subscribe/interaction/interaction'
import { VueConstructor } from 'vue'

export function noteState(interaction: PaidMembershipSubscribeInteraction): VueConstructor {
  if (
    interaction.isShowCreditcard
    || interaction.isInputCreditcard
  ) {
    return NavigationToPlanSelection
  }

  return PaidMembershipPlanNote
}
